// Thư viện hình dán.
//
// Hai loại:
//   kind: "emoji" - vẽ bằng ctx.fillText, KHÔNG cần file ảnh nào
//   kind: "image" - vẽ bằng ctx.drawImage, cần file PNG trong /public
//
// Vì sao chủ yếu dùng emoji: dự án chỉ có sẵn 2 file PNG hình dán. Muốn có
// 60-100 hình dán thì phải đi kiếm/vẽ 60-100 file — tốn thời gian, nặng trang,
// dễ dính bản quyền. Vẽ emoji bằng fillText cho ngay hàng trăm hình dán với 0
// byte tải thêm, lại nét căng ở mọi kích thước vì đó là glyph font.
//
// ⚠️ Đánh đổi: emoji hiển thị KHÁC NHAU giữa macOS / Windows / Android. Ảnh
// xuất ra từ hai máy khác hệ điều hành sẽ không giống nhau ở phần hình dán.
// Nếu sau này cần đồng nhất tuyệt đối thì bổ sung gói PNG — mô hình dữ liệu
// bên dưới đã hỗ trợ sẵn cả hai loại nên không phải viết lại.

const emojiPack = (id, label, icon, chars) => ({
    id,
    label,
    icon,
    items: chars.map((char, i) => ({ id: `${id}-${i}`, kind: "emoji", char }))
});

export const STICKER_PACKS = [
    emojiPack("hearts", "Trái tim", "💕", [
        "❤️", "🩷", "💗", "💖", "💘",
        "💝", "💕", "💞", "💓", "💜",
        "🧡", "💛", "💚", "💙", "🤍"
    ]),
    emojiPack("sparkle", "Lấp lánh", "✨", [
        "✨", "⭐", "🌟", "💫", "⚡",
        "🔮", "🪩", "☄️", "🌙", "🌠"
    ]),
    emojiPack("coquette", "Coquette", "🎀", [
        "🎀", "🩰", "🦢", "🕊️", "🍒",
        "🧸", "💌", "🫧", "👑", "💍"
    ]),
    emojiPack("flowers", "Hoa lá", "🌸", [
        "🌸", "🌷", "🌹", "🌻", "🍀",
        "🌿", "🍃", "🌺", "🌼", "💐"
    ]),
    emojiPack("y2k", "Y2K", "🦋", [
        "🦋", "🌈", "☁️", "💿", "📼",
        "🛼", "☮️", "🍭", "🕶️", "📻"
    ]),
    emojiPack("faces", "Mặt cười", "😻", [
        "😻", "🥰", "😘", "😍", "🤪",
        "😎", "🥹", "😇", "🤗", "😋"
    ]),
    emojiPack("pets", "Thú cưng", "🐰", [
        "🐰", "🐱", "🐶", "🐻", "🐼",
        "🐥", "🦊", "🐨", "🐹", "🐧"
    ]),
    emojiPack("bubbles", "Bong bóng", "💬", [
        "💬", "💭", "❗", "❓", "💯",
        "🔥", "🎉", "🎂", "🎈", "🎁"
    ]),
    emojiPack("food", "Đồ ăn", "🍓", [
        "🍓", "🍰", "🧁", "🍩", "🍦",
        "🥐", "🧋", "🍑", "🍪", "🍬"
    ]),
    {
        id: "jiggleduo",
        label: "Của JiggleDuo",
        icon: "🌿",
        items: [
            { id: "jd-0", kind: "image", src: "/assets/stickers/leaf.png" },
            { id: "jd-1", kind: "image", src: "/assets/stickers/sparkles.png" }
        ]
    }
];

// Kích thước tính trên canvas GỐC (1200×3000), không phải trên màn hình.
export const DEFAULT_STICKER_SIZE = 160;
export const MIN_STICKER_SIZE = 48;
export const MAX_STICKER_SIZE = 700;
